const contribute = [{"key":"contribute.greeting","string":"Hallo {variable}, hier ist eine Übersicht über Ihren Inhalt."},{"key":"contribute.logout","string":"Abmelden"}]

export default contribute



// WEBPACK FOOTER //
// ./src/i18n/de/contribute/_contribute.js